/* src/components/TermsOfService.js - v1.1 - Dynamic Content */
import React, { useState, useEffect } from 'react';

function TermsOfService({ onBack }) {
  const [content, setContent] = useState('<p>Loading...</p>');

  useEffect(() => {
    fetch('/api/public/legal-content')
      .then(res => res.json())
      .then(data => setContent(data.tos || "No terms available."))
      .catch(() => setContent("Failed to load terms."));
  }, []);

  return (
    <div className="feed-container">
      <div className="card" style={{ padding: '40px', lineHeight: '1.6', color: '#ddd' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#1e90ff', cursor: 'pointer', marginBottom: '20px', fontSize: '1rem' }}>← Back</button>
        <h1 style={{ color: 'white', marginTop: 0 }}>Terms of Service</h1>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
}

export default TermsOfService;
